import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import Addproducts from './Addproducts';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import AdminCategory from "./AdminCategory";
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Columnsettings from './Columnsettings';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Adminsalesestimate extends Component {
	
    constructor(props) {
    super(props);
	
	
var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

	
 this.state = {prodid:0,finalValues: ['1','1','1','1','1','1','1','1','1','1','1','1','1','1','1','1'],chekedvalue:['',''] ,sestatus:'',isselectdisplay:false,  checkedvalues:['1','1'],checkboxData:['1','1'],cuscehck:'',companycheck:'',quotecheck:'',quotenumber:'',open:false,btnopen:false,

	codecheck:true,
	descriptioncheck:true,
	categorycheck:true,
	typecheck:true,
	ratecheck:true,
	costcheck:true,
	sellingcheck:true,
	sentcheck:true,
	qunatitycheck:true,
	reordercheck:true,
	ledgercheck:true,
	expenseledgercheck:true,
	Rate2check:true,
	Rate3check:true,
	sellingprice2check:true,
	sellingprice3check:true,
	
	todate1: '', todate: '',
fromdate: '',
 fromdate1:'',company:'',se_quotenumber:'',
redirect:false,pagename:'' ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'se_id',
ProductData:[],ColumnData:[],addopen:false,exportdata:[], columns: [],colcount:0,columnsexport:[],
	  
		
		
	}
	      
	  this.updatProductParent = this.updatProductParent;
	 };
	 
	 updatProductParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage);
	     this.updateColumnssetting=this.updateColumnssetting; 
	 }
	

 myChangeHandler = (event) => {
	
  let nam = event.target.name;
  let val = event.target.value;
  
 
  
  this.setState({[nam]: val});
  

 } 


componentWillMount() {
	document.title = "Isifol - Products and Services";

if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			  this.apicall(this.state.page,this.state.rowsPerPage); 
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		   let strname="Products and Services ";
		   
	 this.props.parentdasCallback(
            strname+"~"
        );
		 



}
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=10')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
        this.apicall(this.state.page,this.state.rowsPerPage); 
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
updateColumnssetting = (text) => 
	{
        this.ColumheadervendorbillApi();
	}
ColumheadervendorbillApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=4&cc_isdisplay=1')
     
  .then(resp => {  	
    if(resp.data.length>0){
		
			this.setState({  
			  ColumnData: resp.data,  
			  colcount:parseInt(resp.data[0].count),
			   	
			});

     }
	 
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=4&cc_isdisplay=1')
     
  .then(resp => {  	
				if(resp.data.length>0){
					
						this.setState({  
						  ColumnData: resp.data,  
						   colcount:parseInt(resp.data[0].count),
						  
						});
			
				 }
	     });
	 }
	 
  
    });
}

apicall(page,rowsPerPage){
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_code='+this.state.quotenumber)
     
  .then(resp => {  	
    if(resp.data.length>0){
		
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  ProductData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy	
			});

     }
	 
	  else{
		   this.setState({ProductData:[],totaldata:0});
	 }
	  this.ColumheadervendorbillApi();
  this.Exportprodapicall();
    });
}

Exportprodapicall(){
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=exportgetall&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&pr_cmp_id='+localStorage.getItem("ISIcmpid"))
     
  .then(resp => { 
 const records = resp.data;  
    if(resp.data.length>0){
		const staticCols = ["pr_code", "pr_description","maincategory","subcategory","prtype","pr_costprice","activetype","pr_vendoritemcode","pr_weight",
		"prunit","pr_expensedescription","pr_reorderlevel","pr_quantityinhand","pr_reorderquantity","pr_location","pr_barcode","pr_notes","le_ledgername","expledger","ve_businessname"];
		const keys = Object.keys(records[0]);
		  const dynamicCols = keys.filter((k) => !staticCols.includes(k));
			this.setState({  
			  exportdata: resp.data,  
			  columnsexport: [...staticCols, ...dynamicCols],
			});

     }
	 
	  else{
		   this.setState({exportdata:[],totaldata:0});
	 }
	 
  
    });
}


 
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
   
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};




  
componentDidMount() { 
localStorage.setItem("page",this.state.rowsPerPage);
	  this.apicall(this.state.page,this.state.rowsPerPage); 
	
	
	}
	
	


  
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}

  
  
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

  }
		
	handleOpen = () => {
    this.setState({ open: true });
  };
handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
	  
		
};

  Handleclickviewmore= (e) =>{
	  
	  this.setState({isselectdisplay:true});
	  
  }
 handleClose = () => {
    this.setState(
      { finalValues: this.state.checkboxData, open: false },
      () => {
        console.log("Final Values:", this.state.finalValues);
      }
    );
  }
 handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
        this.state.codecheck ? "1" : "0",
        this.state.descriptioncheck ? "1" : "0",
        this.state.categorycheck ? "1" : "0",
        this.state.typecheck ? "1" : "0",
        this.state.ratecheck ? "1" : "0",
        this.state.costcheck ? "1" : "0",
        this.state.sellingcheck ? "1" : "0",
        this.state.sentcheck ? "1" : "0",
        this.state.qunatitycheck ? "1" : "0",
        this.state.reordercheck ? "1" : "0",
        this.state.ledgercheck ? "1" : "0",
        this.state.expenseledgercheck ? "1" : "0",
        this.state.Rate2check ? "1" : "0",
        this.state.Rate3check ? "1" : "0",
        this.state.sellingprice2check ? "1" : "0",
        this.state.sellingprice3check ? "1" : "0",
        
        
      ];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
        console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
  
  
  CloseMoreoption = (date) =>{
	
	this.setState({isselectdisplay:false});
}

 
  handlAddProductopen = (val) => {
          this.setState({ prodid: val },()=>{  this.refs.Addproducts.handleProdClose();});     

}
  

	  addcheckbox(){
     setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);

       }

	render()
	{
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
		const { checkedvalues } = this.state;
		}return(
		   <React.Fragment>
	


<Columnsettings 
ref="Columnsettings"  
pageval={4}
updateDonenew={this.updateColumnssetting}
/>
	


	<AdminCategory ref="AdminCategory" />	
<div className="searchbox">

<ul>


 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.quotenumber}
            id="quotenumber"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="quotenumber"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
		  
		  
<li>
From Date
<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }

    onChange={this.fromdatehandler} format="MM/DD/YYYY"
	className="txtbox"
/>  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>
To Date

<p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="datepicker"
onChange={this.toatehandler} format="MM/DD/YYYY"
className="txtbox"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
	
	
	

	

	
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Search 
</Button>

        &nbsp;
        <ReactHTMLTableToExcel
          variant="contained"
          color="primary"
          id="test-table-xls-button"
          className="exportbtn"
          table="Estimate"
          filename="Products Report"
          sheet="Products Report"
          buttonText="EXPORT"
		  
        />
      </p>
		
				
		</li>
	
</ul>




</div>	

 	<div className="split-button-wrap"><p>&nbsp;</p><NavLink  data-tag="primary_action"  className="newitem"  onClick={()=>{this.handlAddProductopen(0)}}>New Item</NavLink><div className="toggle caret newitem button" tag="toggle" tabindex="0" role="button" data-element="open" aria-haspopup="true" aria-label="More actions"><ul className="UIMenu" data-tag="secondary_actions" data-role="secondary_actions" data-ui-widget="UIMenu" data-component="menu"><li className="item_0 last" ><a data-tooltip="Import Journals" aria-haspopup="true" className="UILink" data-tag="journal_import_dialog" data-role="journal_import_dialog" data-ui-widget="UILink" data-component="link" onClick={()=>{this.refs.AdminCategory.handleCategorypanelOpen()}}  >Manage Category</a></li></ul></div></div>


		<div className="clear"></div>
	
	

<div className="estimatebox">
<Paper className={useStyles.root}>

<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}> <SettingsIcon /> </span>
</div>


<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            
  		{this.state.ColumnData.map((col,i) => {  
           return ( 
		    <TableCell>
			{col.cc_displayname}
			
			 </TableCell>
		   
		   )
		   
         })}
		    <TableCell ></TableCell>
          </TableRow>
        </TableHead>

 

  <TableBody>

{stableSort(this.state.ProductData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
 
 
 {this.state.ColumnData.map((cols,i) => { 
	let colsname	=  cols.cc_columnname; 
	console.log(item[""+colsname+""])
	return ( <React.Fragment>
 
	<TableCell>{item[""+colsname+""]}</TableCell>
			</React.Fragment>	);
					})}
<TableCell  >
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.handlAddProductopen(item.pr_id)}}>
Edit
</Button> 
</TableCell>
</TableRow>


				</React.Fragment>	
				);
					})}
					
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
   
 </div>



<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
  <Table stickyHeader aria-label="sticky table" id="Estimate">  
<TableHead> 
<TableRow>

 {this.state.columnsexport.map((col, index) => (
                <TableCell key={index} className="border px-2 py-1 text-left capitalize">
                  {col.replace(/_/g, " ")}
                </TableCell>
              ))}
          
										
                      </TableRow></TableHead>
					  
					  
                      <TableBody>
                     {this.state.exportdata.map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >
{this.state.columnsexport.map((col, j) => (
                <TableCell key={j} className="border px-2 py-1">
                  {item[col] ?? "-"}
                </TableCell>
              ))}
 </TableRow>

 </React.Fragment>	
);
					})}
					
{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="18">No Records</TableCell>
</TableRow>
					) }
					
 </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>



<Addproducts ref="Addproducts" prodid={this.state.prodid}  updateprodnew={this.updatProductParent}/>
  </React.Fragment>

 
		
		)
			
		
	}
	
	
}


  
  

  



  






